module.exports = __webpack_public_path__ + "static/media/la_foret_cafe_2.02bcdd44.jpg";